module.exports = __webpack_public_path__ + "static/img/brees-2015-top-image.548fafa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2015-top-image.jpg
// module id = yHZ5
// module chunks = 1